// Strips control characters, then allows https:// for all hosts and http:// for localhost/127.0.0.1 only.
export function safeHref (url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  // Strip control characters to prevent scheme-bypass attacks like "java\nscript:"
  const normalized = url.replace(/\p{Cc}/gu, '');

  try {
    const { protocol, hostname } = new URL(normalized);
    if (protocol === 'https:') return normalized;
    if (protocol === 'http:' && (hostname === 'localhost' || hostname === '127.0.0.1')) return normalized;
  } catch {
    // unparseable — not a valid absolute URL
  }
  return undefined;
}
